module.exports = __webpack_public_path__ + "media/images/hamburger_custom-c16f3573ff4eabda51d15977f2a15434.svg";